import environment from "../environment";

export const loggingout = () => {
  localStorage.removeItem(environment.TOKEN_KEY);
  localStorage.removeItem(environment.REFRESH_TOKEN_KEY);
  setInterval(() => {
    window.location.href = "/";
    window.location.reload();
  }, 10000);
  // localStorage.removeItem(environment.BACK_URL)
};
